(function () {
  // Checks a 6-digit pincode against the static serviceable-pincode
  // snapshot (assets/serviceable-pincodes.json, ~28.2K pincodes with
  // delivery = Y from our NimbusPost export). Simple yes/no message,
  // no delivery-window estimate. The dataset is fetched once and cached
  // on window for every instance of this snippet on the page.
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('#StpPincodeCheckBtn').forEach(function (btn) {
      var wrapper = btn.closest('.stp-pincode-checker');
      if (!wrapper || wrapper.dataset.bound) return;
      wrapper.dataset.bound = 'true';

      var input = wrapper.querySelector('#StpPincodeInput, .stp-pincode-checker__input');
      var result = wrapper.querySelector('#StpPincodeResult, .stp-pincode-checker__result');

      function setResult(text, variant) {
        result.textContent = text;
        result.className = 'stp-pincode-checker__result stp-pincode-checker__result--' + variant;
        result.hidden = false;
      }

      function loadPincodes() {
        if (window.__stpPincodeSetPromise) return window.__stpPincodeSetPromise;
        window.__stpPincodeSetPromise = fetch(window.stpPincodeDataUrl)
          .then(function (res) {
            if (!res.ok) throw new Error('pincode fetch failed');
            return res.json();
          })
          .then(function (list) {
            return new Set(list);
          });
        return window.__stpPincodeSetPromise;
      }

      btn.addEventListener('click', function () {
        var value = (input.value || '').trim();
        if (!/^[0-9]{6}$/.test(value)) {
          setResult('Please enter a valid 6-digit pincode.', 'invalid');
          return;
        }

        btn.disabled = true;
        btn.textContent = 'Checking...';

        loadPincodes()
          .then(function (set) {
            if (set.has(Number(value))) {
              setResult('Delivery available at this pincode.', 'ok');
            } else {
              setResult("Sorry, we don't deliver here yet.", 'fail');
            }
          })
          .catch(function () {
            setResult('Could not check delivery right now, please try again.', 'invalid');
          })
          .finally(function () {
            btn.disabled = false;
            btn.textContent = 'Check';
          });
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          btn.click();
        }
      });
    });
  });
})();
